import type { Clock } from '@obraplan/core/application/ports/clock';
import { BusinessDate } from '@obraplan/core/domain/date/business-date';

/**
 * Relógio do sistema.
 *
 * O **único** lugar do código onde `new Date()` sem argumento é permitido (RN-123).
 * Qualquer outra ocorrência é falha de revisão: torna a regra dependente do relógio da
 * máquina e impossível de testar com data congelada.
 */
export class SystemClock implements Clock {
  now(): Date {
    return new Date();
  }

  nowIso(): string {
    return new Date().toISOString();
  }

  today(timeZone: string): BusinessDate {
    return BusinessDate.fromInstant(new Date(), timeZone);
  }
}
